'use strict'

define ['./subnavbar.css'], () ->
  (RentappService, $state, $rootScope, Landlord, $cacheFactory) ->
    restrict: "E"
    template: require("./subnavbar.jade")
    link: (scope, element, attrs) ->
      scope.subnav_theme_color = $rootScope.SUBNAV_THEME_COLOR

      subnav = $(".sticky-content")
      stickyFixed = "fixed"
      aboveSubnavHeight = 55
      $(window).scroll ->
        if scope.current_state in ['root.dashboard.applications', 'root.dashboard.forms', 'root.dashboard.applicant_applications'] or scope.current_state.indexOf('settings') >= 0
          if $(this).scrollTop() > aboveSubnavHeight
            subnav.addClass stickyFixed
            scope.$apply () -> scope.buffer_content = true
          else
            subnav.removeClass stickyFixed
            scope.$apply () -> scope.buffer_content = false
        return

      # For checking to show whether or not bank account option should be displayed
      Landlord.getMe().$promise.then (response) ->
        scope.landlord = response
        if scope.landlord.logo
          scope.filename = scope.landlord.logo
      
      RentappService.getMe()
        .then (user) -> 
          scope.companies_visible = user.landlord.in_company

      scope.subnav_states = [
        'root.dashboard.applications',
        'root.dashboard.forms',
        'root.dashboard.applicant_applications',
        'root.dashboard.payments',
        'root.dashboard.payments.not_enabled',
        'root.dashboard.payments.payment_info',
        'root.dashboard.payments.bank_account_info',
        'root.dashboard.payments.confirm',
        'root.dashboard.payments.accounts',
        #'root.dashboard.payments.help',
        'root.dashboard.settings.profile',
        'root.dashboard.settings.notifications',
        'root.dashboard.settings.password',
        'root.dashboard.settings.bank_account',
        'root.dashboard.settings.company',
        'root.dashboard.notifications',
        'root.dashboard.referral',
      ]

      scope.$watch(() ->
        $state.$current.name
      , (newVal, oldVal) ->
        scope.current_state = $state.$current.name
        if scope.current_state in scope.subnav_states
          scope.subnav_active = true
          scope.set_title()
          scope.set_sublink()
        else
          scope.subnav_active = false
      )

      # enable My Payments after my payments activation
      $rootScope.$on 'payment-activated', (event, args) ->
        $cacheFactory.get("$http").removeAll()
        Landlord.getMe().$promise.then (response) ->
          scope.landlord = response

      scope.set_title = () ->
        if scope.current_state in ['root.dashboard.applications', 'root.dashboard.forms', 'root.dashboard.applicant_applications']
          scope.title = "Dashboard"
        else if scope.current_state.indexOf('payments') >= 0
          scope.title = "My Payments"
        else if scope.current_state.indexOf('settings') >= 0
          scope.title = "Settings"
        else if scope.current_state.indexOf('notifications') >= 0
          scope.title = "Email Notification Log"
        else
          scope.title = ""

      scope.set_sublink = () ->
        if scope.current_state in ['root.dashboard.applications', 'root.dashboard.forms']
          scope.sublink = 'main'
        else if scope.current_state.indexOf('settings') >= 0
          scope.sublink = 'settings'
        else
          scope.sublink = ''



// WEBPACK FOOTER //
// ./directives/subnavbar/subnavbar.coffee